// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__s8tNv","wrapper":"styles_wrapper__TdZBe","content":"styles_content__hXmuY"};